import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConfigService } from './services/config.service';

@Injectable({
  providedIn: 'root',
})
export class RouteGuard  {
  _debug:boolean=false;
  debug(msg:string){
    if(this._debug){
      console.log("RouteGuard: "+msg);
    }
  }
  constructor(private config: ConfigService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    this.debug("URL:"+url);
    switch(url){
      case '/simulator':{
        if(!this.config.isConfigured()){
          this.debug("not configured - going to setup");
          this.router.navigate(['/setup']);
        }
      }
      default:{
        return true;
      }
    }
    
  }

  
}